
import api from "./config/axiosConfig";


export type SignUpError = {
  message: string;
};


export const VisionAPI = {
  create: async function (imageUri: string) {
    const formData = new FormData();
    formData.append('file', {
      uri: imageUri,
      name: 'photo.jpg', // default name if fileName is undefined
      type: 'image/jpeg', // e.g., 'image/jpeg'
    } as any);

      const response = await api.request({
        url: `/vision`,
        method: "POST",
        data:formData
      });

      return response.data;
  
  },
  
};
